import { Component, type ReactNode, type ErrorInfo } from 'react';
import { Link } from 'react-router-dom';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background-50 p-4">
          <div className="bg-white rounded-2xl p-8 md:p-10 max-w-lg w-full text-center border border-background-200/70">
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-red-50 mx-auto mb-6">
              <i className="ri-error-warning-line text-red-500 text-3xl"></i>
            </div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-3">500 — Beklenmeyen Hata</h1>
            <p className="text-sm text-foreground-500 mb-2">Sayfa yüklenirken beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.</p>
            {this.state.error && (
              <details className="mt-3 mb-5 text-left">
                <summary className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors">Hata detayını göster</summary>
                <pre className="mt-2 p-3 bg-background-50 rounded-lg text-xs text-foreground-500 overflow-auto max-h-32 whitespace-pre-wrap">
                  {this.state.error.message}
                </pre>
              </details>
            )}
            <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-refresh-line mr-2"></i>Sayfayı Yenile
              </button>
              <Link
                to="/"
                className="px-6 py-3 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-home-4-line mr-2"></i>Anasayfaya Dön
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}